import * as types from '../constants/actionTypes';
import liveStreamService from '../services/liveStreamService';
import stream from '../models/stream';
import * as groupAction from './groupChatActions';
// import * as commonUtils from '../../src/utils/commonUtils';
import WebIM from '../libs/webIM';
import { MSG_TEMPLATE as msgTpl } from '../constants/constants';
import * as commonUtils from '../functions/utils';
import * as myStore from '../store/myStore';
import { TYPE_LIVE_STREAM } from '../constants/messageTypes';
import { ADD_VIEWER_VIEW_LIVE_STREAM } from '../constants/actionTypes';

const configApp = require('../../app');

function getStore() {
  return myStore.getStore();
}

function getloginReducer() {
  return getStore().getState().loginReducer;
}

function getLiveStreamReducer() {
  return getStore().getState().liveStreamReducer;
}

export function addViewerViewLiveStream(streamId, userId) {
  return { type: types.ADD_VIEWER_VIEW_LIVE_STREAM, streamId, userId }
}

export function removeViewerViewLiveStream(streamId, userId) {
  return { type: types.REMOVE_VIEWER_VIEW_LIVE_STREAM, streamId, userId }
}

export function getListLiveStreamsInRoomSuccess(data) {
  return { type: types.GET_LIST_LIVE_STREAM_IN_ROOM_SUCCESS, data };
}

export function setListCurrentLiveStreamInRoomSuccess(data) {
  return { type: types.SET_LIST_CURRENT_LIVE_STREAM_SUCCESS, data };
}

export function selectStreamsSuccess(data) {
  return { type: types.SELECT_STREAM_IN_ROOM_SUCCESS, data };
}

export function selectStreamsPublisherSuccess(data) {
  return { type: types.SELECT_STREAM_PUBLISHER_IN_ROOM_SUCCESS, data };
}

export function getListViewerLiveStreamSuccess(listViewer, streamId) {
  return {
    type: types.GET_STREAM_DETAIL_SUCCESS,
    data: { listViewer, streamId },
  };
}

export function getListLiveStreamSuccess(data) {
  return { type: types.GET_LIST_LIVE_STREAM_SUCCESS, data };
}

export function getListLiveStreamsInRoom(roomId, forceCall = false) {
  return (dispatch, getState) => {
    const selectedGroup = myStore.getStore().getState().groupChatReducer.selectedGroup;
    if (roomId && (selectedGroup?.roomId === roomId || forceCall)) {
      return liveStreamService.getListLiveStreamsInRoom(roomId).then(res => {
        if (res.success) {
          const listLiveStreamInRooms = commonUtils.removeDuplicates(res.data, 'owner_userId');
          if (!configApp || !configApp.isWebApp) {
            // ///////////OPEN/////////////////////////////////////////////
            // work around because of bug from API getListLiveStreamInRoom
            // the response: array[
            // 0: undifined
            // ]
            if (listLiveStreamInRooms.length > 1) {
              dispatch(getListLiveStreamsInRoomSuccess(listLiveStreamInRooms));
            } else {
              if (res.data && res.data[0] && commonUtils.checkEmptyObj(res.data[0])) {
                dispatch(getListLiveStreamsInRoomSuccess([]));
              } else {
                dispatch(getListLiveStreamsInRoomSuccess(listLiveStreamInRooms));
              }
            }
            // ///////////CLOSE/////////////////////////////////////////////
          } else {
            // const listLiveStreamInRoomsShow = [];
            // if (listLiveStreamInRooms.length > 0) {
            //   listLiveStreamInRooms.forEach(item => {
            //     if (item.owner_userId !== getloginReducer().userInfo.userId) {
            //       listLiveStreamInRoomsShow.push(item);
            //     }
            //   });
            // }
            dispatch(getListLiveStreamsInRoomSuccess(listLiveStreamInRooms));
          }
        }
      });
    }
    console.warn("impact roomJid param with current selected group chat");
    return Promise.resolve({ success: false });
  };
}

export function getListLiveStreams() {
  return (dispatch, getState) => {
    return liveStreamService.getListLiveStreams().then(res => {
      if (res.success) {
        // console.log("getListLiveStreams", res.data);
        // let dataStream = stream.mappingStrings(res.data);
        dispatch(getListLiveStreamSuccess(res.data));

        // /Update live members each room
        dispatch(groupAction.updateLiveMember(res.data));
      } else {
        console.log('ERROR: getListLiveStreams', res.message);
      }
    });
  };
}

export function getListViewerLiveStream(streamId) {
  return dispatch => {
    return liveStreamService.getListViewerLiveStream(streamId).then(res => {
      if (res.success) {
        const listViewer = stream.mappingListViewers(res.data);
        dispatch(getListViewerLiveStreamSuccess(listViewer, streamId));

        // /Update live members each room
        // dispatch(groupAction.updateLiveMember(dataStream));
      } else {
        console.log('ERROR: getListLiveStreams', res.message);
      }
    });
  };
}

export function startLiveStream(streamId, roomId, streamName) {
  return dispatch => {
    return liveStreamService.startLiveStream(streamId, roomId, streamName).then(res => {
      if (res.success) {
        dispatch(selectStreamsPublisherSuccess(res.data.items[0]));
        return { success: true, data: res.data.items[0] };
      }
      console.log('ERROR: startLiveStream', res.message);
      return res;
    });
  };
}

export function resetSelectedStreamSuccess(streamId) {
  return { type: types.RESET_SELECTED_STREAM, data: streamId };
}

export function resetLiveStreamInRoom() {
  return { type: types.RESET_LIVE_STREAM_IN_ROOM };
}

export function endLiveStream(xmppId, streamId) {
  return dispatch => {
    return liveStreamService.endLiveStream(xmppId, streamId).then(res => {
      if (res.success) {
        // console.log('endLiveStream', res);
        // dispatch(resetSelectedStreamSuccess(streamId));
        return { success: true, data: res.data };
      }
      console.log('ERROR: endLiveStream', res.message);
      return res;
    });
  };
}

export function watchLiveStreamSuccess(data) {
  return { type: types.WATCH_LIVE_STREAM_SUCCESS, data };
}

export function watchLiveStream(xmppId, streamId, isPublicLiveStream) {
  return dispatch => {
    return liveStreamService.watchLiveStream(xmppId, streamId).then(res => {
      if (res.success) {
        // console.log('watchLiveStream', res.data);
        dispatch(watchLiveStreamSuccess({ streamId }));
        // return {success: true, data: res.data.items[0]};

        // if (!isPublicLiveStream) dispatch(getListViewerLiveStream(streamId));
        // cmt Because func "getListViewerLiveStream" called in chatListener (line 447) issue 5 (RVC-2921)
        return { success: true, data: res.data };
      }
      console.log('ERROR: watchLiveStream', res.message);
      return res;
    });
  };
}

export function sendLiveStreamMessage(chatId, data) {
  // Start live stream
  // Stop live Steam
  //
  // console.log("send data live streams", chatId, streamName);
  return (dispatch, getState) => {
    const msgId = WebIM.conn.getUniqueId();
    const msg = new WebIM.message(TYPE_LIVE_STREAM, msgId);
    msg.set({
      to: chatId,
      data: data || '',
    });
    WebIM.conn.send(msg.body);
  };
}

export function parseFromLocal(type, to, message = {}, bodyType, isSending) {
  const ext = message.ext || {};
  const obj = commonUtils.copyMessage(message, msgTpl.base);
  const body = commonUtils.copyMessage(message, msgTpl[bodyType]);
  return {
    ...obj,
    type,
    to,
    id: WebIM.conn.getUniqueId(),
    body: {
      ...body,
      ...ext,
      type: bodyType,
      sent: !isSending,
    },
  };
}

export function addNewLiveStreamSuccess(data) {
  return { type: types.ADD_NEW_LIVE_STREAM_SUCCESS, data };
}

export function addNewLiveStream(rawStreamName, streamId) {
  return (dispatch, getState) => {
    const newStream = stream.mappingString(rawStreamName, streamId);
    dispatch(addNewLiveStreamSuccess(newStream));
  };
}

export function removeExistLiveStreamSuccess(data) {
  return { type: types.REMOVE_LIVE_STREAM_SUCCESS, data };
}

export function removeExistLiveStream(rawStreamName, streamId) {
  return (dispatch, getState) => {
    const newStream = stream.mappingString(rawStreamName, streamId);
    dispatch(removeExistLiveStreamSuccess(newStream));
  };
}

export function addNewWatcherSuccess(data) {
  return { type: types.ADD_NEW_WATCHER_SUCCESS, data };
}

export function removeWatcherSuccess(data) {
  return { type: types.REMOVE_WATCHER_SUCCESS, data };
}

// export function addNewWatchers(rawStreamName, streamId) {
//     return (dispatch, getState) => {
//         dispatch(addNewWatcherSuccess());
//     };

// }

export function uploadThumbnail(formData) {
  return () => {
    const { loginUserStream } = getLiveStreamReducer();
    const loginReducer = getloginReducer();
    if (loginUserStream.streamId && loginReducer.userInfo) {
      return liveStreamService.uploadThumnailUrl(loginReducer.userInfo.avatarFullUrl, loginUserStream.streamId).then(resp => {
        if (resp.success) {
          return resp;
        }
        return null;
      });
    }
    return null;
  };
}

export function uploadThumbnailMobile(formData) {
  return () => {
    try {
      return liveStreamService.uploadThumnail(formData).then(res => {
        if (res.success) {
          return { success: true, data: res.data };
        }
        console.log('ERROR: upload failed', res.message);
        return res;
      });
    } catch (error) {
      return { success: false, data: '' };
    }
  };
}

export function uploadThumbnailUrlMobile(url, streamId) {
  return () => {
    if (streamId) {
      return liveStreamService.uploadThumnailUrl(url, streamId).then(res => {
        if (res.success) {
          console.log('Upload success ThumnailUrl: ', url);
        }
        return res;
      });
    }
    return { success: false };
  };
}

export function cleanUpLiveStream(roomId) {
  return () => {
    if (roomId) {
      return liveStreamService.cleanUpLiveStream(roomId).then(res => {
        return res;
      });
    }
    return { success: false };
  };
}
